import { render } from "./infoTransferidos.vue?vue&type=template&id=3876ccfe&scoped=true"
import script from "./infoTransferidos.vue?vue&type=script&lang=js"
export * from "./infoTransferidos.vue?vue&type=script&lang=js"

import "./infoTransferidos.vue?vue&type=style&index=0&id=3876ccfe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3876ccfe"]])

export default __exports__